import React from 'react';

import { useProductDependencies } from '../../../controllers/use-product-dependencies';

type PremiumGateForExtensionConfigPanelProps = {
	children: React.ReactNode;
	feature: string;
};

export const PremiumGateForExtensionConfigPanel = ({
	feature,
	children,
}: PremiumGateForExtensionConfigPanelProps): React.JSX.Element => {
	const { ConfigUpsellScreen } = useProductDependencies();

	return ConfigUpsellScreen ? <ConfigUpsellScreen feature={feature} /> : <>{children}</>;
};
